import a from "./highrise1779.mjs";
import t from "./highrise1302.mjs";
import e from "./highrise1316.mjs";
function o() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (e || t)(),
    string: new a()
  };
}
export {
  o as default
};
